import axios from 'axios';

const API = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_MAIN_URL_PATH,
});

// Store logout and toast handlers
let logoutHandler = null;
let toastHandler = null;
let isLoggingOut = false; // Flag to prevent multiple logout attempts

// Function to set handlers from app context
export const setAuthHandlers = (logout, showToast) => {
  logoutHandler = logout;
  toastHandler = showToast;
};

// Function to reset the logout flag (call this on successful login)
export const resetLogoutFlag = () => {
  isLoggingOut = false;
};

API.interceptors.request.use((config) => {
  const token = localStorage.getItem('accessToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

// Response interceptor to handle invalid token
API.interceptors.response.use(
  (response) => {
    // Check if response data indicates invalid token
    // Only trigger logout if user has a token (is logged in)
    if (response.data && response.data.invalidToken === true && !isLoggingOut) {
      const hasToken = localStorage.getItem('accessToken');
      
      if (hasToken) {
        isLoggingOut = true;
        
        if (toastHandler) {
          toastHandler('Your session has expired. Please login again.', 'error');
        }
        
        if (logoutHandler) {
          // Delay logout slightly to ensure toast is shown
          setTimeout(() => {
            logoutHandler();
            // Redirect to login page
            window.location.href = '/';
          }, 500);
        }
      }
    }
    return response;
  },
  (error) => {
    // Check if error response indicates invalid token
    // Only trigger logout if user has a token (is logged in)
    if (error.response && error.response.data && error.response.data.invalidToken === true && !isLoggingOut) {
      const hasToken = localStorage.getItem('accessToken');
      
      if (hasToken) {
        isLoggingOut = true;
        
        if (toastHandler) {
          toastHandler('Your session has expired. Please login again.', 'error');
        }
        
        if (logoutHandler) {
          // Delay logout slightly to ensure toast is shown
          setTimeout(() => {
            logoutHandler();
            // Redirect to login page
            window.location.href = '/';
          }, 500);
        }
      }
    }
    return Promise.reject(error);
  }
);

export default API;